import { useState } from 'react';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import { login } from '../api/client';
import AuthLayout from '../components/AuthLayout';
import PasswordField from '../components/PasswordField';

export default function Login({ onSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const res = await login(email.trim(), password);
      // Password passed up (in memory only) so a forced change does not ask for it twice.
      onSuccess(res.user, password);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  // The error stays inside the form (not a toast) until the user edits a field -
  // it is about what they typed, so it should still be there when they look back.
  return (
    <AuthLayout title="Employee Resource Management" subtitle="Sign in to continue" onSubmit={submit}>
      <Stack spacing={2}>
        {error && <Alert severity="error">{error}</Alert>}
        <TextField
          label="Work email" type="email" value={email} required fullWidth autoFocus
          autoComplete="username"
          onChange={(e) => { setEmail(e.target.value); setError(null); }}
        />
        <PasswordField
          label="Password" value={password} required autoComplete="current-password"
          onChange={(e) => { setPassword(e.target.value); setError(null); }}
        />
        <Button type="submit" variant="contained" size="large" disabled={busy} fullWidth>
          {busy ? 'Signing in…' : 'Sign in'}
        </Button>
      </Stack>
    </AuthLayout>
  );
}
